import React, { memo } from "react";
import { Container, Table, Pagination } from "semantic-ui-react";
import { PAGE_SIZE } from "env.config";
import { PendingRow } from "components/Admin/PendingRow";
import { auditColumns } from "./audit-config";

const AuditHeaderRow = memo(({ columns }) => {
  return (
    <Table.Row>
      {columns.map(({ title, style }, index) => (
        <Table.HeaderCell key={index} style={style}>
          {title}
        </Table.HeaderCell>
      ))}
    </Table.Row>
  );
});

const AuditRow = memo(({ auditItem, columns, onSelect, selectedItem }) => {
  const keys = columns.map((col) => col.title);
  return (
    <Table.Row key={auditItem.Id} active={selectedItem.Id === auditItem.Id} onClick={() => onSelect && onSelect(auditItem)}>
      {keys.map((key, index) => {
        const className = key === "Data" ? "text-ellipsis" : null;
        return (
          <Table.Cell key={index} className={className}>
            {renderCell(auditItem, key)}
          </Table.Cell>
        );
      })}
    </Table.Row>
  );
});

const renderCell = (auditItem, key) => {
  const val = auditItem[key];
  switch (key) {
    case "Date":
      return new Date(val).toLocaleString();
    default:
      if (typeof val === "object") return JSON.stringify(val);
      return val ?? "--";
  }
};

const AuditTable = memo(({ auditList, selectedItem, isLoaded, paginatorInfo, onSelect, onPageChange }) => {
  const data = !isLoaded ? new Array(PAGE_SIZE).fill(0) : auditList;
  const tableRows = data.map((item, idx) => {
    if (!isLoaded) {
      return <PendingRow columnCount={auditColumns.length} key={idx} />;
    }
    return (
      <AuditRow auditItem={item} key={item.Id} columns={auditColumns} onSelect={onSelect} selectedItem={selectedItem} />
    );
  });

  return (
    <Table className='ui celled table audit-table'>
      <Table.Header>
        <AuditHeaderRow columns={auditColumns} />
      </Table.Header>
      <Table.Body>{tableRows}</Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell colSpan={6}>
            <Container fluid textAlign='right'>
              <Pagination
                activePage={paginatorInfo.currentPage}
                onPageChange={onPageChange}
                totalPages={paginatorInfo.totalPages}
              />
            </Container>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
});

export default AuditTable;
